import { CalendarDate } from "./calendar-date";
export const taskStatus = {
    new: { key: "new", humanReadable: "Incomplete" },
    done: { key: "done", humanReadable: "Complete" },
};
export var RecurrencePattern;
(function (RecurrencePattern) {
    RecurrencePattern["None"] = "None";
    RecurrencePattern["Daily"] = "Daily";
    RecurrencePattern["Weekly"] = "Weekly";
    RecurrencePattern["Monthly"] = "Monthly";
})(RecurrencePattern || (RecurrencePattern = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["Sunday"] = "Sunday";
    DayOfWeek["Monday"] = "Monday";
    DayOfWeek["Tuesday"] = "Tuesday";
    DayOfWeek["Wednesday"] = "Wednesday";
    DayOfWeek["Thursday"] = "Thursday";
    DayOfWeek["Friday"] = "Friday";
    DayOfWeek["Saturday"] = "Saturday";
})(DayOfWeek || (DayOfWeek = {}));
const activeTaskSort = {
    dueDateAscending: "Due date (ascending)",
    dueDateDescending: "Due date (descending)",
};
const completedTaskSort = {
    dueDateAscending: "Due date (ascending)",
    dueDateDescending: "Due date (descending)",
    completedDateAscending: "Completed date (ascending)",
    completedDateDescending: "Completed date (descending)",
};
export { activeTaskSort, completedTaskSort };
export class Task {
    constructor() {
        this.ownerId = null;
        this.parentId = null;
        this.tenantId = null;
        this.text = "";
        this.notes = "";
        this.dueDate = null;
        this.dueDateTime = null;
        this.completedAt = null;
        this.status = "";
        this.taskTypeId = null;
        this.id = null;
        this.recurrencePattern = null;
        this.recurrenceInterval = null;
        this.recurrenceDaysOfWeek = null;
        this.recurrenceDayOfMonth = null;
    }
    when() {
        if (this.dueDate) {
            return this.dueDate.dayEnd();
        }
        else if (this.dueDateTime) {
            return this.dueDateTime;
        }
        return null;
    }
    description() {
        return this.text;
    }
    active() {
        return this.status != taskStatus.done.key;
    }
    overdue() {
        var when = this.when();
        if (when) {
            return when < new Date();
        }
        return false;
    }
    getType() {
        return "task";
    }
    clone() {
        return Task.clone(this);
    }
    static clone(source) {
        var theClone = new Task();
        theClone.id = source.id;
        theClone.dueDate = source.dueDate;
        theClone.dueDateTime = source.dueDateTime;
        theClone.ownerId = source.ownerId;
        theClone.parentId = source.parentId;
        theClone.status = source.status;
        theClone.tenantId = source.tenantId;
        theClone.text = source.text;
        theClone.notes = source.notes;
        theClone.updatedAt = source.updatedAt;
        theClone.completedAt = source.completedAt;
        theClone.taskTypeId = source.taskTypeId;
        theClone.recurrencePattern = source.recurrencePattern;
        theClone.recurrenceInterval = source.recurrenceInterval;
        theClone.recurrenceDaysOfWeek = source.recurrenceDaysOfWeek;
        theClone.recurrenceDayOfMonth = source.recurrenceDayOfMonth;
        return theClone;
    }
    static load(source) {
        var theClone = new Task();
        theClone.id = source.id;
        theClone.dueDate = source.dueDate
            ? CalendarDate.parse(source.dueDate).getOrElse(null)
            : null;
        theClone.dueDateTime = source.dueDateTime ? new Date(source.dueDateTime) : null;
        theClone.ownerId = source.ownerId;
        theClone.parentId = source.parentId;
        theClone.status = source.status;
        theClone.tenantId = source.tenantId;
        theClone.text = source.text;
        theClone.notes = source.notes;
        theClone.updatedAt = source.updatedAt;
        theClone.completedAt = source.completedAt ? new Date(source.completedAt) : null;
        theClone.taskTypeId = source.taskTypeId;
        theClone.recurrencePattern = source.recurrencePattern || null;
        theClone.recurrenceInterval = source.recurrenceInterval || null;
        theClone.recurrenceDaysOfWeek = source.recurrenceDaysOfWeek || null;
        theClone.recurrenceDayOfMonth = source.recurrenceDayOfMonth || null;
        return theClone;
    }
}
//# sourceMappingURL=task.js.map